export const url = 'https://banefilter-api.no/wp-json/wp/v2/posts/';
export const homeProducts = 'https://banefilter-api.no/wp-json/wp/v2/posts?categories=26';
export const importantNews = 'https://banefilter-api.no/wp-json/wp/v2/posts?categories=33';
export const news = 'https://banefilter-api.no/wp-json/wp/v2/posts?categories=32';
export const productsUrl = 'https://banefilter-api.no/wp-json/wp/v2/posts?categories=27&per_page=100';